/* istanbul ignore file */

import styled from "styled-components/macro";
import { Paper } from "@mui/material";

export const FormWrapper = styled(Paper)`
  padding: ${(): string => `0 20px 10px`};
`;
